import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "M19.974 4v5h-5zM3.47 11.999a.487.487 0 0 0 .528-.47C4.245 7.307 7.748 4 11.974 4c1.781 0 3.501.6 4.9 1.686l-2.607 2.607A1 1 0 0 0 14.974 10h5a1 1 0 0 0 1-1V4a1.002 1.002 0 0 0-1.707-.707l-1.682 1.682A9 9 0 0 0 11.975 3C7.218 3 3.276 6.721 3 11.471a.5.5 0 0 0 .47.528M4.025 20v-5h5zm16.504-8a.487.487 0 0 0-.528.47c-.247 4.223-3.75 7.53-7.976 7.53-1.78 0-3.5-.6-4.9-1.686l2.607-2.607A1 1 0 0 0 9.025 14h-5a1 1 0 0 0-1 1v5a1.002 1.002 0 0 0 1.707.707l1.682-1.682A9 9 0 0 0 12.025 21c4.755 0 8.697-3.721 8.974-8.471a.5.5 0 0 0-.47-.528",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }